import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface MlModalFormProps {
  showMlModal: boolean;
  setShowMlModal: Function;
  selectedRows: string[];
  handleMlClick: Function;
};

export default function MlModalForm({
  showMlModal,
  setShowMlModal,
  selectedRows,
  handleMlClick
}: MlModalFormProps) {
  const [interval, setInterval] = useState<number>(5);
  const [method, setMethod] = useState('mean');

  const handleSubmit = (e: any) => {
    e.preventDefault();
    // close ML modal form
    setShowMlModal(false);
    // CSV export for ML
    handleMlClick(e, 'ml_csv');
  };

  return (
    <Modal
      show={showMlModal}
      // close modal when pressing X button at the top right
      onHide={() => setShowMlModal(false)}
      centered={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>ML CSV Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="aggregateInterval">
            <Form.Label>Aggregate Interval (s)</Form.Label>
            <Form.Control type="number" value={interval} onChange={(e) => setInterval(Number(e.target.value))} />
          </Form.Group>

          <Form.Group className="mb-3" controlId="aggregateMethod">
            <Form.Label>Aggregate Method</Form.Label>
            <Form.Select value={method} onChange={(e) => setMethod(e.target.value)}>
              <option value="mean">Mean</option>
              <option value="concat">Concatenate</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowMlModal(false)}>Cancel</Button>
        <Button variant="primary" type="submit" onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
}
